import { render, staticRenderFns } from "./CrudProductAttributeItem.vue?vue&type=template&id=11de5830&scoped=true&"
import script from "./CrudProductAttributeItem.vue?vue&type=script&lang=js&"
export * from "./CrudProductAttributeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11de5830",
  null
  
)

export default component.exports